import React from 'react';
import { Target, Users, Heart } from 'lucide-react';
import { aboutData } from '../data/mockData';

const AboutSection = () => {
  const stats = aboutData.stats || [];
  
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16 animate-fadeInUp">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6">
            {aboutData.title}
          </h2>
          <div className="w-24 h-1 bg-blue-600 mx-auto mb-8 rounded-full"></div>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-6 animate-fadeInLeft">
            <p className="text-lg text-gray-700 leading-relaxed">
              {aboutData.description}
            </p>

            <div className="space-y-4 pt-6">
              <div className="flex items-start space-x-4 group">
                <div className="bg-blue-100 p-3 rounded-lg group-hover:bg-blue-200 transition-colors duration-300">
                  <Target className="w-6 h-6 text-blue-600" />
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-1">Fokus Dampak Nyata</h3>
                  <p className="text-gray-600">
                    Setiap kegiatan dirancang untuk memberikan manfaat langsung kepada masyarakat yang membutuhkan.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4 group">
                <div className="bg-blue-100 p-3 rounded-lg group-hover:bg-blue-200 transition-colors duration-300">
                  <Users className="w-6 h-6 text-blue-600" />
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-1">Kolaborasi Anak Muda</h3>
                  <p className="text-gray-600">
                    Menggerakkan generasi muda untuk bersama-sama menciptakan perubahan positif.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4 group">
                <div className="bg-blue-100 p-3 rounded-lg group-hover:bg-blue-200 transition-colors duration-300">
                  <Heart className="w-6 h-6 text-blue-600" />
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-1">Transparansi Penuh</h3>
                  <p className="text-gray-600">
                    Dokumentasi lengkap setiap kegiatan untuk memastikan akuntabilitas dan kepercayaan.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Stats */}
          <div className="grid grid-cols-1 gap-6 animate-fadeInRight">
            {stats.length > 0 && stats[0] && (
              <div className="bg-gradient-to-br from-blue-50 to-white p-8 rounded-2xl border border-blue-100 hover:shadow-lg transition-all duration-300 hover:scale-105">
                <div className="text-5xl font-bold text-blue-600 mb-2">
                  {stats[0].number}
                </div>
                <div className="text-gray-700 font-medium">
                  {stats[0].label}
                </div>
              </div>
            )}
            
            {stats.length > 1 && stats[1] && (
              <div className="bg-gradient-to-br from-blue-50 to-white p-8 rounded-2xl border border-blue-100 hover:shadow-lg transition-all duration-300 hover:scale-105">
                <div className="text-5xl font-bold text-blue-600 mb-2">
                  {stats[1].number}
                </div>
                <div className="text-gray-700 font-medium">
                  {stats[1].label}
                </div>
              </div>
            )}
            
            {stats.length > 2 && stats[2] && (
              <div className="bg-gradient-to-br from-blue-50 to-white p-8 rounded-2xl border border-blue-100 hover:shadow-lg transition-all duration-300 hover:scale-105">
                <div className="text-5xl font-bold text-blue-600 mb-2">
                  {stats[2].number}
                </div>
                <div className="text-gray-700 font-medium">
                  {stats[2].label}
                </div>
              </div>
            )}

            {/* Vision Box */}
            <div className="bg-blue-600 p-8 rounded-2xl text-white hover:shadow-xl transition-all duration-300 hover:scale-105">
              <h3 className="text-2xl font-bold mb-3">Visi Kami</h3>
              <p className="leading-relaxed">
                Menjadi platform terdepan yang menginspirasi dan memberdayakan anak muda Indonesia untuk menciptakan dampak sosial yang berkelanjutan.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
